import SettingsShell from '../settings/SettingsShell.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { CRM_MANAGER_PERMISSIONS } from 'dashboard/constants/permissions.js';

const CRM_PERMISSIONS = [
  'administrator',
  'agent',
  'contact_manage',
  CRM_MANAGER_PERMISSIONS,
];
const CRM_SETTINGS_PERMISSIONS = ['administrator', CRM_MANAGER_PERMISSIONS];
const CRM_MANAGER_ROUTE_PERMISSIONS = [
  'administrator',
  CRM_MANAGER_PERMISSIONS,
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/prospecting'),
    name: 'prospecting',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.PROSPECTING,
    },
    component: () => import('../prospecting/Index.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm'),
    name: 'yescrm_dashboard',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmPipelines.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/funis/:pipelineId'),
    name: 'yescrm_board',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmBoard.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/negociacoes/:dealId'),
    name: 'yescrm_deal_detail',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmDealDetail.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/configuracoes'),
    component: SettingsShell,
    meta: { settingsSection: true },
    children: [
      {
        path: '',
        name: 'yescrm_settings',
        meta: {
          permissions: CRM_SETTINGS_PERMISSIONS,
          featureFlag: FEATURE_FLAGS.CRM,
        },
        component: () => import('./CrmSettings.vue'),
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/produtos'),
    name: 'yescrm_products',
    meta: {
      permissions: CRM_SETTINGS_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmProducts.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/atividades'),
    name: 'yescrm_activities',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmActivities.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/metas-comissoes'),
    name: 'yescrm_goals_commissions',
    meta: {
      permissions: CRM_MANAGER_ROUTE_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmGoalsCommissions.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/automacoes'),
    name: 'yescrm_automations',
    meta: {
      permissions: CRM_SETTINGS_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmAutomations.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/auditoria'),
    name: 'yescrm_audit',
    meta: {
      permissions: CRM_MANAGER_ROUTE_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmAudit.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/yescrm/relatorios'),
    name: 'yescrm_reports',
    meta: {
      permissions: CRM_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CRM,
    },
    component: () => import('./CrmReports.vue'),
  },
];
